export default "__VITE_ASSET__CYqthzkm__"